import React from "react";
import "./Photo.css";

export default function Photos(props) {
  if (props.photos) {
    return (
      <section className="Photos">
        <div className="container">
          <div className="row">
            {props.photos.map(function (photo, index) {
              return (
                <div className="col-4" key={index}>
                  <a href={photo.src.original} target="_blank" rel="noreferrer">
                    <img
                      src={photo.src.landscape}
                      className="img-fluid"
                      alt={photo.src.photographer}
                      width={840}
                    />
                  </a>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    );
  } else {
    return null;
  }
}
